import { AppDispatch, AppState } from '@nxsys/store';
import { employeeActions } from '@nxsys/store/slices/employee/reducer/employeeSlice';
import { GetListTimesheetsParams } from '@nxsys/store/slices/timesheets/type';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimesheetsEmployeeListing from './TimesheetsEmployeeListing';

const TimesheetsEmployee = () => {
  const { user } = useSelector((state: AppState) => state.appStore);

  const dispatch = useDispatch<AppDispatch>();

  const { loading, list, pagination, queryParams } = useSelector(
    (state: AppState) => state.employeeStore.timesheetList,
  );

  const getTimeSheetList = (params: GetListTimesheetsParams) => {
    const newParams = {
      ...params,
      taxYear: undefined,
      notHasAgency: true,
    };

    dispatch(
      employeeActions.getTimesheetEmployeeList({
        id: user?.subcontractorId?.id ?? '',
        ...newParams,
      }),
    );
  };

  return (
    <TimesheetsEmployeeListing
      timesheetsData={{
        list,
        pagination,
        queryParams,
      }}
      loading={loading}
      getTimeSheetList={getTimeSheetList}
    />
  );
};

export default React.memo(TimesheetsEmployee);
